import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { MonLogType } from 'src/app/model/admin/mon-log-type';

@Injectable({
  providedIn: 'root',
})
export class MonLogTypeTableService extends BaseTableService<MonLogType> {
  constructor() {
    super();
  }
}
